import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useTheme, useMediaQuery } from '@chakra-ui/react';
import { error } from '../utils/logger.js';

// For whatever reason fails when copied 1:1 from
// https://github.com/hausgold/designsystem-web/blob/migrate-to-chakra/testing/__tests__/hooks/useBreakpoint.jsx

/**
 * Provides a simple way to get the current breakpoint range from screen size.
 * This hook is a wrapper of `chakra-ui`'s `useMediaQuery` which relies on `window.matchMedia`.
 */
var useBreakpoint = function useBreakpoint(breakpoint) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '>';
  var _useTheme = useTheme(),
    themeBreakpoints = _useTheme.breakpoints;
  var breakpointValue = themeBreakpoints[breakpoint];
  var comparatorString = comparator === '>' ? 'min' : 'max';
  var _useMediaQuery = useMediaQuery("(".concat(comparatorString, "-width: ").concat(breakpointValue, ")")),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    isWithinMediaBreakpoint = _useMediaQuery2[0];
  if (!breakpointValue) {
    error('The given breakpoint key can not be found in the theme.', 'useBreakpoint', !breakpointValue);
    return false;
  }
  return isWithinMediaBreakpoint;
};
export { useBreakpoint };